<template>
    <div>
        <div class="container">
            <h5> <strong> Daftar Peserta </strong> </h5>
            <table class="table w-full">
                    <thead>
                        <tr>
                            <th> No  </th>
                            <th> Nama Perusahaan  </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(participant, index) in participants" :key="index">
                            <td>{{index+1}}</td>
                            <td>{{participant.participant.member.name}}</td>
                        </tr>
                    </tbody>
            </table>
        </div>
    </div>
</template>


<script>
import axios from 'axios';

export default {
    data() {
        return {
            participants: [],
        }
    },

    mounted() {
        const id = this.$route.params.id;
        axios.get(`${process.env.VUE_APP_BACKEND_URL}/api/events/${id}/participants`, {
            params: {
                size: -1
            }
        })
            .then((res) => {
                this.participants = res.data.data;
            })
            .catch((err) => {
                console.log(err);
            })
    }

}
</script>